import Script from 'next/script'
import { getAppConfig } from '@/config/config'
import React from 'react'

const config = getAppConfig()
const basePath = config.basePath

export default function IFrameResizer() {
  return (
    <Script
      id="iframeResizer"
      src={`${basePath}/scripts/iframeResizer.min.js`}
      strategy="beforeInteractive"
      onLoad={() => console.log('[iFrameResizer] loaded iFrameResizer script')}
      onError={(error) => console.error('[iFrameResizer] Error while loading iFrameResizer script')}
    />
  )
}
